import React from 'react';

interface NavItemProps {
    icon: React.ReactNode;
    label: string;
    section: string;
    activeSection: string;
    setActiveSection: (section: string) => void;
}

export default function NavItem({ icon, label, section, activeSection, setActiveSection }: NavItemProps): React.ReactElement {
  const isActive = activeSection === section;
  const baseClasses = "flex flex-col items-center p-2 rounded-xl transition-all duration-300 md:w-auto md:h-auto w-16 h-16 justify-center";
  const activeClasses = "bg-black/60 text-green-300 shadow-lg shadow-green-400/80";
  const inactiveClasses = "text-gray-400 hover:bg-green-900/20 hover:text-green-400";
  const hover3DClasses = "transform hover:-translate-y-1 hover:scale-110 hover:shadow-xl hover:shadow-green-500/70";
  const classNames = [baseClasses, isActive ? activeClasses : inactiveClasses, hover3DClasses].join(' ');
  return (
      <button onClick={() => setActiveSection(section)} className={classNames} aria-label={label}> 
          {icon} 
          <span className="text-xs mt-1 hidden md:block font-medium">{label}</span> 
      </button>
  );
}